import { Component, OnInit, Inject, ViewChild, AfterViewInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Customer } from '@app/models/customers/Customer';
import { AuthService } from '@app/services/auth.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Hotel } from '../../../models/hotels/Hotel';

export interface DialogData {
    current: number;
    hotel: Hotel;
    desktopTemplate: string;
    images: any[];
    videos: any[];
    to800: boolean;
    showSave: boolean;
}

@Component({
    selector: 'app-tvangebotimagevideo',
    templateUrl: './tvangebotimagevideo.component.html',
    styleUrls: ['./tvangebotimagevideo.component.scss'],
    standalone: false
})
export class TvangebotimagevideoComponent implements OnInit, AfterViewInit, OnDestroy {
    images: any[];
    videos: any[];
    hotel: Hotel;
    title: string = '';
    currentImage: number = 0;
    savedPos: number = 0;
    totalcount: number = 0;
    currentImagePosition: number = 0;
    currentCustomer: Customer;
    currentMiniImagePosition: number = 0;
    desktopTemplate: string = 'xl';
    currentNavViedo: boolean = false;
    showSave: boolean = false;
    showText: boolean = false;
    private unsubscribe$ = new Subject();
    @ViewChild('imageslidercontent') imageslidercontent: { nativeElement: { offsetWidth: number; scrollLeft: number; }; };
    constructor(
        @Inject(MAT_DIALOG_DATA) private data: DialogData,
        public dialogRef: MatDialogRef<TvangebotimagevideoComponent>,
        private auth: AuthService,
        private cdr: ChangeDetectorRef
    ) { }

    ngOnInit(): void {
        this.currentImage = this.data?.current;
        this.hotel = this.data.hotel;
        this.desktopTemplate = this.data?.desktopTemplate;
        this.currentImagePosition = this.currentImage;
        this.currentMiniImagePosition = this.currentImage;
        this.images = this.data.images;
        this.videos = this.data.videos;
        this.showSave = this.data.showSave;
        this.title = this.hotel?.name;
        if (this.images?.length === 0) {
            this.totalcount = this.videos?.length;
            this.currentNavViedo = true;
        } else {
            this.totalcount = this.images?.length;
        }

        this.auth.auth$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((customer: Customer) => {
            this.currentCustomer = customer;
        });
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    ngAfterViewInit() {
        setTimeout(() => {
            const scrollPos = this.imageslidercontent.nativeElement.offsetWidth * this.currentImage;
            this.imageslidercontent.nativeElement.scrollLeft = scrollPos;
        });
    }

    async scrolling() {
        if (this.imageslidercontent && this.imageslidercontent.nativeElement) {
            const wd = this.imageslidercontent.nativeElement.offsetWidth;
            const sc = this.imageslidercontent.nativeElement.scrollLeft;
            if (wd > 0) {
                this.currentImage = Math.round(sc / wd);
            }
        }
        this.currentImagePosition = this.currentImage;
        this.currentMiniImagePosition = this.currentImage;
    }

    async keydown(ev) {
        if (ev.keyCode === 39) {
            this.next(ev);
        }
        if (ev.keyCode === 37) {
            this.previus(ev);
        }
    }

    async setCurrent(ev, k) {
        ev.stopPropagation();
        this.currentImage = k;
        // this.currentMiniImagePosition = k;
        const scrollPos = this.imageslidercontent.nativeElement.offsetWidth * this.currentImage;
        this.imageslidercontent.nativeElement.scrollLeft = scrollPos;
    }

    async previus(ev) {
        ev.stopPropagation();
        if (this.imageslidercontent && this.imageslidercontent.nativeElement) {
            if (this.currentImage > 0) {
                this.currentImage -= 1;
                // this.currentMiniImagePosition = this.currentImage;
                const scrollPos = this.imageslidercontent.nativeElement.offsetWidth * this.currentImage;
                this.imageslidercontent.nativeElement.scrollLeft = scrollPos;
            }
        }
    }

    async next(ev) {
        ev.stopPropagation();
        if (!this.currentNavViedo) {
            if (this.imageslidercontent && this.imageslidercontent.nativeElement) {
                if (this.currentImage < this.data?.images?.length - 1) {
                    this.currentImage += 1;
                    // this.currentMiniImagePosition = this.currentImage;
                    const scrollPos = this.imageslidercontent.nativeElement.offsetWidth * this.currentImage;
                    this.imageslidercontent.nativeElement.scrollLeft = scrollPos;
                }
            }
        } else {
            if (this.imageslidercontent && this.imageslidercontent.nativeElement) {
                if (this.currentImage < this.data?.videos?.length - 1) {
                    this.currentImage += 1;
                    // this.currentMiniImagePosition = this.currentImage;
                    const scrollPos = this.imageslidercontent.nativeElement.offsetWidth * this.currentImage;
                    this.imageslidercontent.nativeElement.scrollLeft = scrollPos;
                }
            }
        }
    }

    async changeNav(ev) {
        if (this.videos?.length > 0 && this.images?.length > 0) {
            this.currentNavViedo = !this.currentNavViedo;
            this.currentImage = 0;
            this.currentImagePosition = 0;
            this.currentMiniImagePosition = 0;
            this.totalcount = this.currentNavViedo ? this.videos?.length : this.images?.length;
            this.setCurrent(ev, 0);
        } else if (this.videos?.length > 0) {
            this.currentNavViedo = true;
            this.totalcount = this.videos.length
        } else if (this.videos?.length > 0) {
            this.totalcount = this.images.length;
            this.currentNavViedo = false;
        }
    }

    saveBilder() {
        this.savedPos = this.currentImage;
        this.showText = true;

        setTimeout(() => {
            this.showText = false;
        }, 500);
    }

    onClose(): void {
        this.dialogRef.close(this.savedPos);
    }

    async handelError(k) {
        try {
            if (this.images[k]) {
                this.images.splice(k, 1);
            }
            this.cdr.markForCheck();
        } catch (error) {
            console.log(error)
        }
    }
}
